import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { CATEGORIES } from '../Categories/constant';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  HeroDescription,
  CategoriesSection,
  SectionTitle,
  SectionSubtitle,
  CategoriesGrid,
  CategoryCard,
  CategoryImageWrapper,
  CategoryImage,
  CategoryOverlay,
  CategoryName,
  CategoryArrow,
  BackgroundPattern,
} from './Products.styled';

const Products = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Hero animation variants
  const heroVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const heroSubtitleVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay: 0.2,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const heroDescriptionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay: 0.4,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  // Categories grid animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const sectionTitleVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <PageContainer>
      <Header />
      {/* <HeroSection>
        <BackgroundPattern />
        <HeroContent>
          <HeroTitle
            variants={heroVariants}
            initial="hidden"
            animate="visible"
          >
            Our Products
          </HeroTitle>
          <HeroSubtitle
            variants={heroSubtitleVariants}
            initial="hidden"
            animate="visible"
          >
            Premium Quality Solutions
          </HeroSubtitle>
          <HeroDescription
            variants={heroDescriptionVariants}
            initial="hidden"
            animate="visible"
          >
            Discover our comprehensive range of industrial and construction
            products, designed to meet the highest standards of quality and
            durability.
          </HeroDescription>
        </HeroContent>
      </HeroSection> */}
      <CategoriesSection>
        <SectionSubtitle
          variants={sectionTitleVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          Browse Categories
        </SectionSubtitle>
        <SectionTitle
          variants={sectionTitleVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          Explore Our Product Range
        </SectionTitle>

        <HeroDescription
          variants={heroDescriptionVariants}
          initial="hidden"
          animate="visible"
        >
          Discover our comprehensive range of industrial and construction
          products, designed to meet the highest standards of quality and
          durability.
        </HeroDescription>

        <CategoriesGrid
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {CATEGORIES.map((category, index) => (
            <CategoryCard
              key={category.slug}
              variants={cardVariants}
              as={Link}
              to={`/products/${category.slug}`}
              whileHover={{ y: -10, scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            >
              <CategoryImageWrapper>
                <CategoryImage
                  src={category.image}
                  alt={category.name}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
                <CategoryOverlay
                  initial={{ opacity: 0 }}
                  whileHover={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  <CategoryArrow
                    initial={{ x: -20, opacity: 0 }}
                    whileHover={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    →
                  </CategoryArrow>
                </CategoryOverlay>
              </CategoryImageWrapper>
              <CategoryName>{category.name}</CategoryName>
            </CategoryCard>
          ))}
        </CategoriesGrid>
      </CategoriesSection>
      <Footer />
    </PageContainer>
  );
};

export default Products;
